import { choiceIconRegistry } from "../choiceIconRegistry";

const svgProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  width: 40,
  height: 40,
};

export const registerGlassDamageChoiceIcons = () => {
  choiceIconRegistry.register(
    "chip_star",
    <svg {...svgProps}>
      <circle cx={12} cy={12} r={2.5} />
      <line x1={12} y1={4} x2={12} y2={8.5} />
      <line x1={12} y1={15.5} x2={12} y2={20} />
      <line x1={4} y1={12} x2={8.5} y2={12} />
      <line x1={15.5} y1={12} x2={20} y2={12} />
      <line x1={6.3} y1={6.3} x2={9.8} y2={9.8} />
      <line x1={14.2} y1={14.2} x2={17.7} y2={17.7} />
      <line x1={17.7} y1={6.3} x2={14.2} y2={9.8} />
      <line x1={9.8} y1={14.2} x2={6.3} y2={17.7} />
    </svg>,
  );

  choiceIconRegistry.register(
    "crack",
    <svg {...svgProps}>
      <line x1={2} y1={4} x2={8} y2={10} />
      <line x1={8} y1={10} x2={6} y2={14} />
      <line x1={6} y1={14} x2={10} y2={17} />
      <line x1={10} y1={17} x2={9} y2={22} />
      <circle cx={8} cy={10} r={1} fill="currentColor" stroke="none" />
    </svg>,
  );

  choiceIconRegistry.register(
    "shattered",
    <svg {...svgProps}>
      <circle cx={12} cy={12} r={1.5} fill="currentColor" stroke="none" />
      <line x1={12} y1={12} x2={5} y2={3} />
      <line x1={12} y1={12} x2={12} y2={2} />
      <line x1={12} y1={12} x2={19} y2={3} />
      <line x1={12} y1={12} x2={22} y2={10} />
      <line x1={12} y1={12} x2={21} y2={18} />
      <line x1={12} y1={12} x2={15} y2={22} />
      <line x1={12} y1={12} x2={9} y2={22} />
      <line x1={12} y1={12} x2={3} y2={18} />
      <line x1={12} y1={12} x2={2} y2={10} />
      <line x1={7} y1={5.5} x2={4} y2={9} />
      <line x1={16} y1={5} x2={20} y2={8} />
      <line x1={19} y1={15} x2={16} y2={20} />
      <line x1={5} y1={15} x2={8} y2={20} />
    </svg>,
  );
};
